import GiftCardDisclaimer from '@moncler/components/product/GiftCardDisclaimer';
import api from '@utils/api';
import classNames from 'classnames';
import React, { Suspense, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analyticsStone from '@stone/utils/analytics';
import { useSelector } from 'react-redux';
const ExpressPaymentsButtons = React.lazy(() => import(/* webpackChunkName: "component-expresspaymentsbuttons" */ './ExpressPaymentsButtons'));
const ExpressPaymentsMinicart = (props) => {
    var _a;
    const { t } = useTranslation();
    const { modalExpressPaymentsOpen, isOpen, onLoad } = props;
    const [paymentMethods, setPaymentMethods] = useState();
    const [adyenConfig, setAdyenConfig] = useState();
    const [bag, setBag] = useState();
    const [closeTs, setCloseTs] = useState(); // trick to forse method deselection
    const backRef = useRef(null);
    const { minicart } = useSelector((state) => state.minicart);
    const firstRender = useRef(true);
    useEffect(() => {
        if (modalExpressPaymentsOpen) {
            setTimeout(() => {
                var _a;
                (_a = backRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1000);
        }
        if (modalExpressPaymentsOpen && firstRender.current) {
            firstRender.current = false;
            api.getPaymentMethods().then((data) => {
                onLoad();
                setPaymentMethods(data);
            });
            api.getAdyenConfig().then((data) => {
                onLoad();
                setAdyenConfig(data);
            });
            api.getFullCart().then((data) => {
                onLoad();
                setBag(data);
            });
        }
    }, [modalExpressPaymentsOpen]);
    useEffect(() => {
        api.getFullCart().then((data) => {
            setBag(data);
            setCloseTs(new Date());
            props.onClose();
        });
    }, [minicart === null || minicart === void 0 ? void 0 : minicart.items]);
    // OE-24851 workaround to use both arrow with different behaviors
    const addArrowAfterClick = () => {
        const paymentDiv = document.querySelector('.minibag__expresspayment__intro');
        if (paymentDiv) {
            paymentDiv.classList.add('button--arrow-left');
        }
    };
    return (React.createElement("div", { id: "expressCheckoutMinicart", tabIndex: -1, "aria-label": t('checkout.expresscheckoutintro'), className: classNames('minibag__expresspayment', { open: isOpen }) }, !(((_a = bag === null || bag === void 0 ? void 0 : bag.items) === null || _a === void 0 ? void 0 : _a.length) > 0) || window.noguestcheckout || window.noexpresscheckout || (bag === null || bag === void 0 ? void 0 : bag.exchangeModel) ? undefined : (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "minibag__expresspayment__intro button button--tertiary button--arrow-left", ref: backRef, onClick: () => {
                addArrowAfterClick();
                setCloseTs(new Date());
                props.onClose();
            } },
            React.createElement("span", { className: "visually-hidden" },
                t('button.close'),
                " "),
            t('checkout.expresscheckout')),
        React.createElement(GiftCardDisclaimer, { checkouturl: props.checkouturl, bag: minicart }),
        React.createElement(Suspense, { fallback: React.createElement("div", { className: "wrapper-loading" },
                React.createElement("span", null, t('label.loading'))) },
            React.createElement(ExpressPaymentsButtons, Object.assign({}, props, { onBackPress: () => {
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById('expressCheckoutMinicart')) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 200);
                }, adyenConfig: adyenConfig, paymentMethods: paymentMethods, bag: bag, noDisclaimer: true, reloadtimestamp: closeTs, analyticsStone: (payment) => {
                    analyticsStone.expressCheckout('submit', 'minibag', payment);
                } })))))));
};
export default ExpressPaymentsMinicart;
